import { create } from 'zustand';
import type { SortDirection } from '@scio3/shared-types';
import { SORT_DIRECTION } from '@scio3/shared-types';

export type AssetSortField = 'originalFileName' | 'createdAt' | 'lastUpdatedDate';
export type FolderOrder = 'folders-first' | 'combined';

interface AssetSortState {
  sortField: AssetSortField;
  sortDirection: SortDirection;
  folderOrder: FolderOrder;
  setSort: (field: AssetSortField, direction: SortDirection) => void;
  setFolderOrder: (order: FolderOrder) => void;
}

const STORAGE_KEY = 'scio3-asset-sorting';

function loadSort(): {
  sortField: AssetSortField;
  sortDirection: SortDirection;
  folderOrder: FolderOrder;
} {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        sortField: parsed.sortField || 'createdAt',
        sortDirection: parsed.sortDirection || SORT_DIRECTION.DESC,
        folderOrder: parsed.folderOrder || 'folders-first',
      };
    }
  } catch {
    // ignore parse errors
  }
  return {
    sortField: 'createdAt',
    sortDirection: SORT_DIRECTION.DESC,
    folderOrder: 'folders-first',
  };
}

const initial = loadSort();

export const useAssetSortStore = create<AssetSortState>((set, get) => ({
  sortField: initial.sortField,
  sortDirection: initial.sortDirection,
  folderOrder: initial.folderOrder,
  setSort: (sortField, sortDirection) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ sortField, sortDirection, folderOrder: get().folderOrder }),
    );
    set({ sortField, sortDirection });
  },
  setFolderOrder: (folderOrder) => {
    const { sortField, sortDirection } = get();
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ sortField, sortDirection, folderOrder }));
    set({ folderOrder });
  },
}));
